<div class="dialog">
  <div class="dialog__title" mat-dialog-title>
    <div class="dialog__header">
      <mds-icon [width]="28" [height]="28" [key]="mdsIcon.REVIEW"></mds-icon>
      <h2>Review {{ data?.selectedRsl?.name ?? '' }}</h2>
    </div>
    <mat-icon
      class="dialog__close"
      role="button"
      aria-label="Close"
      mat-dialog-close
      >close</mat-icon
      >
    </div>

    <div class="dialog__content" mat-dialog-content>
      @if (data.selectedProducts) {
        <section class="dialog__section">
          <div class="section__title">
            <div class="product_title">{{ data?.selectedProducts[0]?.name }}</div>
          </div>
        </section>
      }
      @if (data?.declaration?.statement) {
        <section class="dialog__section">
          <div class="section__title">
            <h5 class="statement_title">Compliance Statement</h5>
          </div>
          <div class="statement_container">
            <div class="statement_container_content">
              <div class="statement_title_container">
                <div class="title">Statement</div>
                <div class="title_value">*</div>
              </div>
              <div class="statement_container_value">
                <div class="statement_container_value_content">
                  <div class="statement_value">
                    {{ data?.declaration?.statement }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      }
      @if (data?.sku_exemptions.length) {
        <section class="dialog__section">
          @if (
            currentStatement === statementStatus.COMPLIANT_WITH_EXEMPTION ||
            currentStatement === statementStatus.NON_COMPLIANT
            ) {
            <div
              class="section__exemptions"
              >
              <div class="section__exemptions__header">
                <mat-label>{{
                  currentStatement === statementStatus.COMPLIANT_WITH_EXEMPTION
                  ? 'Exemptions'
                  : 'Cause of Non-Compliance'
                }}</mat-label>
              </div>
              <mds-grid
                [overrides]="exemptionOverrides"
                (gridReady)="onGridReady($event)"
                [minHeight]="'200'"
                [sizeColumnsToFit]="true"
              ></mds-grid>
            </div>
          }
        </section>
      }
      <section class="dialog__section">
        @if (data.attachments.length) {
          <div
            class="section__title attachments-title"
            >
            <h5>Attachments</h5>
            <p>
              New documents will be attached to each selected product. All previous
              documents remain intact.
            </p>
          </div>
        }
        <div class="attachments">
          @if (data.attachments.length) {
            <div
              class="attachments--previously-uploaded"
              >
              @for (attachment of data.attachments; track attachment; let i = $index) {
                <ng-container
              *ngTemplateOutlet="
                attachmentItem;
                context: { attachment, index: i, isLocalUpload: false }
              "
                ></ng-container>
              }
            </div>
          }
        </div>
      </section>
      @if (data?.selectedProducts?.length === 1) {
        <app-compliance-questionnaire-comments
          [data]="data"
          (commentChanged)="changeComment($event)"
          (commentSubmit)="submitComment($event)"
        ></app-compliance-questionnaire-comments>
      }
    </div>

    <div class="dialog__actions" mat-dialog-actions align="end">
      <mds-button type="secondary" (click)="onStatusUpdate('Reject')"
        >Reject</mds-button
        >
        <mds-button
          class="actions__save ml-20"
          type="primary"
          (click)="onStatusUpdate('Approve')"
          >Approve</mds-button
          >
        </div>
      </div>
      <ng-template
        #attachmentItem
        let-attachment="attachment"
        let-index="index"
        let-isLocalUpload="isLocalUpload"
        >
        <div class="uploaded">
          <div class="uploaded__tile" [tabIndex]="0">
            <div class="uploaded__icon">
              <mds-icon
                [key]="mdsIcon.ATTACHMENT"
                [width]="20"
                [height]="20"
              ></mds-icon>
            </div>
            <div class="uploaded__content">
              <div class="uploaded__title">{{ attachment?.original_name ?? '' }}</div>
              <div class="uploaded__attached">Attached to: Product</div>
            </div>
          </div>
          @if (!isLocalUpload) {
            <div
              class="uploaded__download"
              [matTooltip]="'Download'"
              (click)="onAttachmentDownload(index)"
              aria-label="Download"
              [tabIndex]="0"
              >
              <mds-icon
                [key]="mdsIcon.DOWNLOAD"
                [width]="24"
                [height]="24"
                [pathColors]="['#42454B']"
              ></mds-icon>
            </div>
          }
        </div>
      </ng-template>
